   import React from "react";
import { ToastContainer } from "react-toastify";
   
  const TemplateRightForm = ({
  includeHeader,
  template,
  headerImage,
  headerVideo,
  headerDocument,
  includeButtons,
  getDocumentExtension,
  formatFileSize,
  renderFormattedText,
  replaceVariables,
}) => {
     return (
       <>
  <ToastContainer/>
  {/* ================= RIGHT MOBILE PREVIEW ================= */}
          <div className="w-1/3 flex justify-center items-center montserrat-font-1">
            <div>
              <h3 className="text-center font-medium mb-4 text-green-800">
                Sample Message Preview
              </h3>

              <div className="mobile-card montserrat-font-1">
                <div className="mobile-top"></div>
                <div className="mobile-speaker"></div>
                <div className="mobile-camera"></div>
                <div className="mobile-btn1"></div>
                <div className="mobile-btn2"></div>
                <div className="mobile-btn3"></div>

                <div className="mobile-card-int">
                  <div className="bubble-container">
                    {/* MESSAGE BUBBLE */}
                    <div className="message-bubble message-bubble-animate">
                      {/* HEADER */}
                      {includeHeader &&
                        template.headerType === "Text" &&
                        template.headerText && (
                          <div className="header-text">
                            {template.headerText}
                          </div>
                        )}

                      {includeHeader &&
                        template.headerType === "Image" &&
                        headerImage && (
                          <img
                            src={URL.createObjectURL(headerImage)}
                            alt="preview"
                            style={{ width: "100%", borderRadius: "5px" }}
                          />
                        )}

                      {includeHeader &&
                        template.headerType === "Video" &&
                        headerVideo && (
                          <video
                            controls
                            src={URL.createObjectURL(headerVideo)}
                            style={{ width: "100%", borderRadius: "5px" }}
                          />
                        )}

                      {includeHeader &&
                        template.headerType === "Document" &&
                        headerDocument && (
                          <div className="w-full rounded-lg overflow-hidden bg-[#f1f3f4] mb-2 border border-gray-200">
                            <div className="h-28 bg-[#fafafa] flex items-center justify-center">
                              <div className="relative">
                                <div className="w-16 h-20 bg-white rounded-md border border-gray-300 shadow-sm flex flex-col items-center justify-center">
                                  <span className="text-2xl">📄</span>
                                  <span className="text-[10px] font-bold text-gray-700 mt-1">
                                    {getDocumentExtension(headerDocument.name)}
                                  </span>
                                </div>

                                <div className="absolute -bottom-2 -right-2 bg-green-500 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs shadow">
                                  ✓
                                </div>
                              </div>
                            </div>

                            <div className="bg-white px-3 py-2 border-t border-gray-200">
                              <p className="text-[12px] font-semibold text-gray-900 truncate m-0">
                                {headerDocument.name}
                              </p>

                              <div className="flex items-center justify-between mt-1">
                                <p className="text-[10px] text-gray-500 m-0">
                                  {getDocumentExtension(headerDocument.name)}{" "}
                                  Document
                                </p>

                                <p className="text-[10px] text-gray-500 m-0">
                                  {formatFileSize(headerDocument.size)}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                      {/* BODY */}
                      {template.body && (
                        <div
                          className="body-text"
                          dangerouslySetInnerHTML={{
                            __html: renderFormattedText(
                              replaceVariables(template.body),
                            ),
                          }}
                        />
                      )}

                      {/* FOOTER */}
                      <div className="footer-text">{template.footer}</div>

                      <div className="message-time">
                        {new Date().toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </div>
                    </div>

                    {/* BUTTONS */}
                    {includeButtons && (
                      <div className="button-bubble button-bubble-animate">
                        {template.showButton4_quick1 && (
                          <div className="button-text">
                            {template.showButton4_quick1}
                          </div>
                        )}

                        {template.showButton4_quick2 && (
                          <div className="button-text">
                            {template.showButton4_quick2}
                          </div>
                        )}

                        {template.showButton4_quick3 && (
                          <div className="button-text">
                            {template.showButton4_quick3}
                          </div>
                        )}

                        {template.showButton4_quick4 && (
                          <div className="button-text">
                            {template.showButton4_quick4}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
           </>
  );
};

export default TemplateRightForm;